import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useState } from "react";
import Firstscreen from "./screens/FirstScreen";
import SecondScreen from "./screens/SecondScreen";

export default function Container() {
  const [username, setusername] = useState();
  /*
  useEffect(() => {
    window.onbeforeunload = () => {
      console.log("rah yab3at khou");
      socket.emit("delete_me", username);
    };
  });
*/
  return (
    <Box h="100vh">
      {username ? (
        <SecondScreen username={username} />
      ) : (
        <Firstscreen setUsernameHandler={setusername} />
      )}
    </Box>
  );
}
